/**
 * Wraps an async function. Kept for call-site compatibility; timing logs are disabled.
 */
export function withTiming<TArgs extends unknown[], TReturn>(
  _name: string,
  fn: (...args: TArgs) => Promise<TReturn>
): (...args: TArgs) => Promise<TReturn> {
  return fn
}
